module.exports = __webpack_public_path__ + "static/gallery7-cb8cff9dcb47b17c6d8c3ddb4ff02a35.png";